import { CircularIconButton } from '#app/components/Buttons/CircularIconButton.js';
import { Text } from '#app/components/Primitives/Text.js';
import { AddIcon } from '@contra/icons/icons';
import { css, styled } from 'styled-components';

type InlineEditingEmptyPlaceholderProps = {
  readonly label: string;
  readonly onClick: () => void;
};

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;

    // this negative margin + extra width ensures we match the width of the other inline editing components which are also styled this way
    margin-left: -12px;
    width: calc(100% + 24px);

    padding: 16px;
    border-radius: 10px;

    cursor: pointer;

    background-color: ${theme.colorsV2.gray05};

    :hover {
      background-color: ${theme.colorsV2.gray10};
    }

    transition: background-color 0.2s ease-out;
  `}
`;

const Label = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray80};
  `}
`;

export const InlineEditingEmptyPlaceholder = ({
  label,
  onClick,
}: InlineEditingEmptyPlaceholderProps) => {
  return (
    <Container
      onClick={onClick}
      role="button"
    >
      <CircularIconButton
        icon={AddIcon}
        onClick={onClick}
        size="xsmall"
        variant="V2Secondary"
      />
      <Label>{label}</Label>
    </Container>
  );
};
